<div class="dash-card-tpl"
  [ngClass]="klass"
  [class.with-border]="withBorder">
  @if (header) {
    <div
      class="dash-card-tpl-header">
      <ng-content select="[dash-card-header]"></ng-content>
    </div>
  }
  <div class="dash-card-tpl-body">
    <ng-content select="[dash-card-body]"></ng-content>
  </div>
  @if (footer) {
    <div
      class="dash-card-tpl-footer">
      <ng-content select="[dash-card-footer]"></ng-content>
    </div>
  }
</div>
